import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { setSession } from "./sessionUtil";

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      setSession(null);
      window.open(
        process.env.REACT_APP_URL || "http://localhost:3000",
        "_self"
      );
    }

    return Promise.reject(error);
  }
);

function getToken(): string | null {
  return localStorage.getItem("accessToken");
}

axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = getToken();

    // Se o token existir, adicione-o ao cabeçalho Authorization
    if (token) {
      config.headers = config.headers || {}; // Assegura que o headers não seja undefined
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    // Se ocorrer um erro antes de enviar a requisição, rejeite a promessa
    return Promise.reject(error);
  }
);

axiosInstance.defaults.baseURL =
  process.env.REACT_APP_API_URL ||
  "https://nervous-marquita-asconn-08c97d95.koyeb.app/";
axiosInstance.defaults.headers.common["Content-Type"] = "application/json";
//axiosInstance.defaults.headers.common["Access-Control-Allow-Origin"] = 'http://127.0.0.1:3000'

export default axiosInstance;

//javascript
//"proxy": "http://127.0.0.1:8080",
